import {FC} from 'react';

export const TotalConsumption: FC = () => {
    return (
        <svg
            width="58"
            height="58"
            viewBox="0 0 58 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3318_138815)">
                <rect
                    width="58"
                    height="58"
                    rx="8"
                    fill="#FFE8EB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M28.9982 43.6155C37.0701 43.6155 43.6136 37.072 43.6136 29.0002C43.6136 20.9283 37.0701 14.3848 28.9982 14.3848C20.9263 14.3848 14.3828 20.9283 14.3828 29.0002C14.3828 37.072 20.9263 43.6155 28.9982 43.6155ZM29.4479 18.7694V27.14L34.8444 27.14L28.5485 39.2309V30.8603H23.152L29.4479 18.7694Z"
                    fill="#F55B85"
                />
            </g>
            <defs>
                <clipPath id="clip0_3318_138815">
                    <rect
                        width="58"
                        height="58"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const Sessions: FC = () => {
    return (
        <svg
            width="59"
            height="58"
            viewBox="0 0 59 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3318_138601)">
                <rect
                    x="0.5"
                    width="58"
                    height="58"
                    rx="8"
                    fill="#E0F0E3"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M43.5356 20.52L43.5533 20.5022L36.94 13.8889L35.0556 15.7733L38.8067 19.5244C37.1356 20.1644 35.9444 21.7644 35.9444 23.6667C35.9444 26.12 37.9356 28.1111 40.3889 28.1111C41.0289 28.1111 41.6156 27.9689 42.1667 27.7378V40.5556C42.1667 41.5333 41.3667 42.3333 40.3889 42.3333C39.4111 42.3333 38.6111 41.5333 38.6111 40.5556V32.5556C38.6111 30.6 37.0111 29 35.0556 29H33.2778V16.5556C33.2778 14.6 31.6778 13 29.7222 13H19.0556C17.1 13 15.5 14.6 15.5 16.5556V45H33.2778V31.6667H35.9444V40.5556C35.9444 43.0089 37.9356 45 40.3889 45C42.8422 45 44.8333 43.0089 44.8333 40.5556V23.6667C44.8333 22.44 44.3356 21.32 43.5356 20.52ZM40.3889 25.4444C39.4111 25.4444 38.6111 24.6444 38.6111 23.6667C38.6111 22.6889 39.4111 21.8889 40.3889 21.8889C41.3667 21.8889 42.1667 22.6889 42.1667 23.6667C42.1667 24.6444 41.3667 25.4444 40.3889 25.4444ZM30.9575 29.2016C30.9575 32.7678 28.0664 35.6589 24.5002 35.6589C20.9339 35.6589 18.0429 32.7678 18.0429 29.2016C18.0429 25.6353 20.9339 22.7443 24.5002 22.7443C28.0664 22.7443 30.9575 25.6353 30.9575 29.2016ZM27.5365 29.6283C27.8865 29.4127 27.8865 28.8738 27.5365 28.6582L23.2054 25.9905C22.8554 25.7749 22.4179 26.0443 22.4179 26.4755V31.811C22.4179 32.2421 22.8554 32.5116 23.2054 32.296L27.5365 29.6283Z"
                    fill="#5EC46C"
                />
            </g>
            <defs>
                <clipPath id="clip0_3318_138601">
                    <rect
                        width="58"
                        height="58"
                        fill="white"
                        transform="translate(0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

